/**
 * @generated SignedSource<<faa8e101359d09b1e7c7088c88f3e79f>>
 * @relayHash e5d31b3bf6835b2002a3285bce1c60e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ec87ea51b14cdd7b94416bde99366c886ea881ae07def013b4f4000f8d407e2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type useUpdateCoverPictureMutationPageUpdateMutation$variables = {
  pageId: string;
  propertyKey: string;
  propertyValue: string;
};
export type useUpdateCoverPictureMutationPageUpdateMutation$data = {
  readonly confluence: {
    readonly updateValuePageProperty: {
      readonly pageProperty: {
        readonly key: string;
        readonly value: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useUpdateCoverPictureMutationPageUpdateMutation = {
  response: useUpdateCoverPictureMutationPageUpdateMutation$data;
  variables: useUpdateCoverPictureMutationPageUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyKey"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "propertyValue"
},
v3 = [
  {
    "concreteType": "ConfluenceMutationApi",
    "kind": "LinkedField",
    "name": "confluence",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "propertyKey"
              },
              {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
              },
              {
                "kind": "Variable",
                "name": "value",
                "variableName": "propertyValue"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "ConfluenceUpdateValuePagePropertyPayload",
        "kind": "LinkedField",
        "name": "updateValuePageProperty",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "ConfluencePageProperty",
            "kind": "LinkedField",
            "name": "pageProperty",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useUpdateCoverPictureMutationPageUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUpdateCoverPictureMutationPageUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "e5d31b3bf6835b2002a3285bce1c60e3",
    "id": "1ec87ea51b14cdd7b94416bde99366c886ea881ae07def013b4f4000f8d407e2",
    "metadata": {},
    "name": "useUpdateCoverPictureMutationPageUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation useUpdateCoverPictureMutationPageUpdateMutation($propertyKey:String!,$pageId:ID!,$propertyValue:String!){confluence{updateValuePageProperty(input:{key:$propertyKey,pageId:$pageId,value:$propertyValue}){success,pageProperty{key,value}}}}"
  }
};
})();

(node as any).hash = "9be000566cb8905515caaa483176090b";

export default node;
